// extracted by mini-css-extract-plugin
module.exports = {"minPriceContainer":"min_price_panel_minPriceContainer__2PjQS","minPriceContent":"min_price_panel_minPriceContent__1gRuo","minPrice":"min_price_panel_minPrice__39j-7"};